import { CommonAPI, Token } from './common'
import {
  ForgotPassword2FARequest,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  Login2FARequest,
  Login2FAResponse,
  LoginRequest,
  LoginResponse,
  MobileOTPRequestRequest,
  MobileOTPRequestResponse,
  MobileOTPResendRequest,
  MobileOTPResendResponse,
  MobileOTPVerifyRequest,
  MobileOTPVerifyResponse,
  PasskeyLoginOptionResponse,
  PasskeyLoginVerifyRequest,
  PasskeyLoginVerifyResponse,
  ResetPasswordRequest,
  SessionRequestResponse
} from './types'

import { baseURL } from './constants'
import { attachDeviceMeta } from './utils'

export class AnonymousAuthAPI extends CommonAPI {
  constructor(token: Token) {
    super({ baseURL })

    this.filterRequestPayload()
    attachDeviceMeta(this.injectRequest)

    this.updateToken(token)
  }

  public login = (data: LoginRequest) => {
    return this.api.post<LoginResponse>('/login', data)
  }

  public login2FA = (data: Login2FARequest) => {
    return this.api.post<Login2FAResponse>('/login/2fa', data)
  }

  public forgotPassword = (data: ForgotPasswordRequest) => {
    return this.api.post<ForgotPasswordResponse>('/forgot-password', data)
  }

  public forgotPassword2FA = (data: ForgotPassword2FARequest) => {
    return this.api.post('/forgot-password/2fa', data)
  }

  public resetPassword = (data: ResetPasswordRequest) => {
    return this.api.post('/reset-password', data)
  }

  public sessionRequest = () => {
    return this.api.post<SessionRequestResponse>('/login/anonymous-session')
  }

  public mobileOTPRequest = (data: MobileOTPRequestRequest) => {
    return this.api.post<MobileOTPRequestResponse>('/login/mobile', data)
  }

  public mobileOTPResend = (data: MobileOTPResendRequest) => {
    return this.api.post<MobileOTPResendResponse>('/login/mobile/resend', data)
  }

  public mobileOTPVerify = (data: MobileOTPVerifyRequest) => {
    return this.api.post<MobileOTPVerifyResponse>('/login/mobile/verify', data)
  }

  public emailVerificationConfirm = <T extends object>(params: T) => {
    return this.api.post('/profile/email/verification/confirm', undefined, {
      params
    })
  }

  public passkeyLoginOption = () => {
    const data = {
      server_host: self.origin
    }

    return this.api.post<PasskeyLoginOptionResponse>(
      '/login/passkey/option',
      data
    )
  }

  public passkeyLoginVerify = (data: PasskeyLoginVerifyRequest) => {
    return this.api.post<PasskeyLoginVerifyResponse>(
      '/login/passkey/verify',
      data
    )
  }
}
